import React from 'react'
import Container from '@/components/container'
import { Button } from 'antd'

import './index.less'

export default function notFound (props) {
  return (
    <Container>
      <div className='not-found-wrap'>
        <img src='//img30.360buyimg.com/pop/jfs/t1/123336/27/4823/5992/5ee357eeE3dd72fab/2ccbc82af26b9ab6.png' />
        <div className='not-found-des'>页面走丢了</div>
        <Button onClick={() => props.history.push('/')}>返回首页</Button>
      </div>
    </Container>
  )
}
